'use strict';
const defaultConfig = {
    filled: false
}
/**
 * Show a spinner inside a given element
 * @param {element} $target - Element to block by the veil and spinner.
 *                            Pass body to block the whole page.
 */
function addSpinner($target, config) {
    var $veil = $('<div class="veil"><div class="underlay"></div></div>');
    if (config.filled) {
        $veil = $('<div class="veil opacity-100 bg-white"><div class="underlay bg-white"></div></div>');
    }
    $veil.append('<div class="spinner"><svg fill="#c000" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><style>.spinner_ajPY{transform-origin:center;animation:spinner_AtaB .75s infinite linear}@keyframes spinner_AtaB{100%{transform:rotate(360deg)}}</style><path d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" fill="#fff"/><path d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z" fill="#c00" class="spinner_ajPY"/></svg></div>');
    if ($target.get(0).tagName === 'IMG') {
        $target.after($veil);
        $veil.css({ width: $target.width(), height: $target.height() });
        if ($target.parent().css('position') === 'static') {
            $target.parent().css('position', 'relative');
        }
    } else {
        if (!$target.find('.veil').length) {
            $target.append($veil);
            if ($target.css('position') === 'static') {
                $target.parent().css('position', 'relative');
                $target.parent().addClass('veiled');
            }
            if ($target.get(0).tagName === 'BODY') {
                $veil.find('.spinner').css('position', 'fixed');
            }
        }
    }
    $veil.click(function (e) {
        e.stopPropagation();
    });
}

/**
 * Remove existing spinner
 * @param  {element} $veil - jQuery pointer to the veil element
 */
function removeSpinner($veil) {
    setTimeout(function () {
        if ($veil.parent().hasClass('veiled')) {
            $veil.parent().css('position', '');
            $veil.parent().removeClass('veiled');
        }
        $veil.off('click');
        $veil.remove();
    }, 800);
}

// element level spinner:
$.fn.spinner = function () {
    var $element = $(this);
    var Fn = function () {
        this.start = function (config) {
            var spinnerConfig = {
                ...defaultConfig,
                ...config
            }
            if ($element.length) {
                addSpinner($element, spinnerConfig);
            }
        };
        this.stop = function () {
            if ($element.length) {
                var $veil = $('.veil');
                removeSpinner($veil);
            }
        };
    };
    return new Fn();
};

// page-level spinner:
$.spinner = function () {
    var Fn = function () {
        this.start = function () {
            addSpinner($('body'), defaultConfig);
        };
        this.stop = function () {
            removeSpinner($('.veil'));
        };
    };
    return new Fn();
};
